<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="证件号码" 
    innerValue="{{innerValue}}"
    isDisable="{{isPhoneDisable}}"
    nameTips="{{nameTips}}"
  >
    <es-field placeholder="请输入证件号码" wx:model="{{innerValue}}" bind:focus="phoneFocus" bindblur="onBlur" slot="input"/>
  </from-item>

</template>

<script>
import { watch } from "@mpxjs/core";

  import { createComponent } from '@didi/es-mpx-creator'
  import { AES_ECB_DECRYPT } from '@/common/crypto'
  import { hasRequired,permitValidateConf } from '@/utils'
  import Validator from '@/utils/validator'
  createComponent({
    classes: [],
    data: {
      innerValue:'',
      nameTips:''
    },
    props: {
      userDetail:{
        type: Object,
        value: {}
      },
      value:{
        type: String,
        value: ''
      },
      isAddPage:{
        type: Boolean,
        value: true
      },
      isPhoneDisable:{
        type: Boolean,
        value: false
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow:{
        type: Boolean,
        value: false
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
      cardType:{
        type: Object,
        value: {}
      }
    },
    computed: {
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      },
      phoneNumber() {
        return AES_ECB_DECRYPT(this.userDetail?.mobile_no || '')
      },
    },
    methods: {
      //联系电话输入框聚焦
      phoneFocus() {
        this.$trigger( 'phone-focus' )
      },
      onBlur(e){
        const validateConf = permitValidateConf(this.cardType)  
        var validator = new Validator()  
        validator.cbAdd(this.innerValue, validateConf, '请输入正确的证件号码')
        this.nameTips = validator.start()
        if(!this.nameTips && this.cardType.code === '1'){
          var birDayCode = this.innerValue.substring(6,14);
          const check = this.checkBirthDayCode(birDayCode);
          this.nameTips = check? '':'请输入正确的证件号码'
        }
      },
      /*校验日期码*/
      checkBirthDayCode: function(birDayCode){
          var check = /^[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(birDayCode);
          if(!check) return false;
          var yyyy = parseInt(birDayCode.substring(0,4),10);
          var mm = parseInt(birDayCode.substring(4,6),10);
          var dd = parseInt(birDayCode.substring(6),10);
          var xdata = new Date(yyyy,mm-1,dd);
          if(xdata > new Date()){
              return false;//生日不能大于当前日期
          }else if ( ( xdata.getFullYear() == yyyy ) && ( xdata.getMonth () == mm - 1 ) && ( xdata.getDate() == dd ) ){
              return true;
          }else{
              return false;
          }
      },
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      phoneNumber(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
      cardType: {
        immediate: true,
        deep: true,
        handler(val) {
          this.nameTips= ''
        }
      }
    },
    mounted() {
      this.innerValue = this.isAddPage ? '' : this.phoneNumber
    }
  })
</script>

<style lang='stylus' scoped>
.input-error
  position absolute
  left 0px
  top 35px
  font-family PingFangSC-Regular
  font-size 11px
  font-weight normal
  line-height 14px
  letter-spacing 0px
  color #DD080B
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item'
    }
  }
</script>

